
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import CompanyIntroSection from './components/CompanyIntroSection';
import MissionValuesSection from './components/MissionValuesSection';
import ProcessSection from './components/ProcessSection';
import ExpertiseSection from './components/ExpertiseSection';
import ClientsTestimonialsSection from './components/ClientsTestimonialsSection';
import CTASection from './components/CTASection';
import ToolsSection from '../../components/feature/ToolsSection';

export default function About() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <Header />
      <main>
        <HeroSection />
        <CompanyIntroSection />
        <MissionValuesSection />
        <ToolsSection />
        <ProcessSection />
        {/* <ExpertiseSection /> */}
        {/* <ClientsTestimonialsSection /> */}
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
